import { render, staticRenderFns } from "./ProjectListingSN5.vue?vue&type=template&id=1ab355d2&"
import script from "./ProjectListingSN5.vue?vue&type=script&lang=js&"
export * from "./ProjectListingSN5.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListingSN5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports